const sortBySortOrder = (districts) => {
  districts.sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
}

export default {
  ADD_ITEM (state, item) {
    state.districts.push(item)
    sortBySortOrder(state.districts)
  },
  SET_DISTRICTS (state, districts) {
    state.districts = districts
  },
  UPDATE_DISTRICT (state, district) {
    const index = state.districts.findIndex((d) => d.id === district.id)
    Object.assign(state.districts[index], district)
    sortBySortOrder(state.districts)
  },
  REMOVE_ITEM (state, itemId) {
    const index = state.districts.findIndex((d) => d.id === itemId)
    state.districts.splice(index, 1)
  }
}
